import { withSvgIcon } from './withSvgIcon';

export const ShieldSlashed = withSvgIcon(
  <>
    <path
      d="M18.1643 4.73969L12 2L3 6C3 6 2.99997 11.7627 5.65626 16.5M8 19.5784C9.08222 20.6158 10.3987 21.4662 12.0001 22C18.9838 19.6721 20.5483 11.3228 20.8988 7.69875"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M4 18.5L20 3.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
